import { useRef } from "react";
import { useLocation, useParams } from "react-router";

import { QuoteDetails } from "~/features/quote/index.tsx";

export const QuotePage = () => {
	const { quoteId } = useParams();
	const location = useLocation();
	// Stable key logic: avoid remounting when transitioning within the quote
	// flow so client-only state like the applied template is preserved.
	//
	// Remount occurs when:
	//  - No quoteId (new quote) — each navigation gets a unique location.key
	// No remount when:
	//  - quoteId first appears after Get Quote (new→quoted transition)
	//  - quoteId changes after re-submission (revised quote gets a new id)
	//  - Same quoteId across step transitions (details↔carrier↔shipment)
	const stableKeyRef = useRef(quoteId ?? location.key);

	if (!quoteId) {
		stableKeyRef.current = location.key;
	}

	return <QuoteDetails key={stableKeyRef.current} />;
};
